<div class="orders" class="page-layout carded fullwidth" style="width: 100%;">
    <div class="top-bg primary"></div>

    <div class="center">
        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">
            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'CONTAINER_INFORMATION' | translate}}</span>
            </div>
        </div>
        <!-- / HEADER -->
        <div id="dashboard-project" class="page-layout carded fullwidth inner-scroll" fxLayout="row">
            <div class="center" fusePerfectScrollbar>
                <mat-card class="my-20" fxLayout="row">
                    <!-- CENTER -->
                    <div class="center w-100-p" fusePerfectScrollbar>
                        <!-- CONTENT CARD -->
                        <div class="w-100-p">
                            <mat-tab-group fxLayout="column" fxFlex="100">
        
                                <mat-tab label="{{'DEVICE_INFORMATION'|translate}}">
                                    <div class="w-100-p chart-card p-24"  style="background-color: #424242 !important;">
                                        <div class="chart-form w-100-p" style="color: white; display: flex; justify-content: end;">
                                            <mat-form-field appearance="outline">
                                                <mat-label style="color: white;">{{'SELECT_DATE' |translate}}</mat-label>
                                                <input matInput [matDatepicker]="picker" [(ngModel)]="selectTime" (dateChange)="getContainerTimeClick()">
                                                <mat-datepicker-toggle style="color: white;" matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                        <div class="w-100-p">
                                            <div id="msfChart" class="w-100-p">
                                                <apx-chart class="w-100-p"
                                                [series]="msfChartOptions.series"
                                                [chart]="msfChartOptions.chart"
                                                [xaxis]="msfChartOptions.xaxis"
                                                [yaxis]="msfChartOptions.yaxis"
                                                [theme]="msfChartOptions.theme"
                                                [dataLabels]="msfChartOptions.dataLabels"
                                                [grid]="msfChartOptions.grid"
                                                [stroke]="msfChartOptions.stroke"
                                                [title]="msfChartOptions.title"
                                                ></apx-chart>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chart-card p-24">
                                        <div class="w-100-p " fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="10px grid">
                                            <mat-form-field color="accent">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [(ngModel)]="startDate" [max]="endDate" (dateChange)="getByDateBetweenRequests()"  [matDatepicker]="pickerStart">
                                                <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerStart></mat-datepicker>
                                            </mat-form-field>
                                              
                                            <mat-form-field color="accent">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput  [min]="startDate" (dateChange)="getByDateBetweenRequests()"  [(ngModel)]="endDate" [matDatepicker]="pickerEnd">
                                                <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                                                <mat-datepicker #pickerEnd color="primary"></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                        <div class="my-20" fxLayout="row wrap" fxLayoutGap="20px grid" fxLayoutAlign="space-evenly">
                                                <div fxFlex="100" fxFlex.gt-sm="50">
                                                    <div class="chart-card p-12">
                                                        <div id="heatChart">
                                                            <apx-chart
                                                            [series]="heatChartOptions.series"
                                                            [chart]="heatChartOptions.chart"
                                                            [xaxis]="heatChartOptions.xaxis"
                                                            [yaxis]="heatChartOptions.yaxis"
                                                            [theme]="heatChartOptions.theme"
                                                            [dataLabels]="heatChartOptions.dataLabels"
                                                            [grid]="heatChartOptions.grid"
                                                            [stroke]="heatChartOptions.stroke"
                                                            [title]="heatChartOptions.title"
                                                            ></apx-chart>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div fxFlex="100" fxFlex.gt-sm="50">
                                                    <div class="chart-card p-12">
                                                        <div id="batChart">
                                                            <apx-chart
                                                              [series]="batChartOptions.series"
                                                              [chart]="batChartOptions.chart"
                                                              [xaxis]="batChartOptions.xaxis"
                                                              [yaxis]="batChartOptions.yaxis"
                                                              [theme]="batChartOptions.theme"
                                                              [dataLabels]="batChartOptions.dataLabels"
                                                              [grid]="batChartOptions.grid"
                                                              [stroke]="batChartOptions.stroke"
                                                              [title]="batChartOptions.title"
                                                            ></apx-chart>
                                                          </div>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </mat-tab>
        
                                <mat-tab label="{{'DEVICE_LOGS'|translate}}">
                                    <div class="content-card">
                                        <div class="orders-table  p-24" fusePerfectScrollbar>
                                            
                                            <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table 
                                                [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc"
                                                fusePerfectScrollbar>
        
        
                                                <ng-container matColumnDef="name">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'NAME'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        {{container!=null?container.name:"---"}}
                                                    </mat-cell>
                                                </ng-container>
                                          
                                                <ng-container matColumnDef="slr">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'SOLAR_VOLTAGE'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        {{device.solarEnerjiVoltaj!=null?device.solarEnerjiVoltaj/100:"---"}}V
                                                    </mat-cell>
                                                </ng-container>
        
                                                <ng-container matColumnDef="bat">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'BATTERY'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        {{device.batarya!=null?device.batarya/100:"---"}}V
                                                    </mat-cell>
                                                </ng-container>
        
                           
                                                <ng-container matColumnDef="sck">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'CPU_HEAT'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        {{device.cpuSicaklik!=null?device.cpuSicaklik/10:"---"}}°C
                                                    </mat-cell>
                                                </ng-container>
        
        
                                                <ng-container matColumnDef="msf">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'OCCUPANCY'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        {{device.mesafe!=null?((device.mesafe|containerMsf:container.altitude:container.deadZone)|number : '1.2-2'):"---"}}%
                                                    </mat-cell>
                                                </ng-container>
        
                                                <ng-container matColumnDef="alarmType">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'ALARM_TYPE'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        {{(device.alarmType |AlarmTypePipe)|translate}}
                                                    </mat-cell>
                                                </ng-container>
        
                                                <ng-container matColumnDef="date">
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{'DATE'|translate}}
                                                    </mat-header-cell>
                                                    <mat-cell *matCellDef="let device">
                                                        <p style="overflow: hidden; white-space: normal;"
                                                            class="total-price text-truncate">
                                                            {{device?.sonBaglantiTarih!=null?(device?.sonBaglantiTarih  | date:"dd / MM / y HH:mm"):"---"}}
                                                        </p>
                                                    </mat-cell>
                                                </ng-container>
        
                                                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true">
                                                </mat-header-row>
                                                <mat-row *matRowDef="let device; columns: displayedColumns;" class="order"
                                                    matRipple>
                                                </mat-row>
                                            </mat-table>
                                            
                                            <mat-paginator #paginator [length]="pageLenght" [pageSize]="10" (page)="pageEvent($event)"
                                            [pageSizeOptions]="[10, 50, 100]">
                                        </mat-paginator>
                                        </div>
                                    </div>
                                </mat-tab>
        
                            </mat-tab-group>
                        </div>
                        <!-- / CONTENT CARD -->
                    </div>
                    <!-- / CENTER -->
                </mat-card>
            </div>
        </div>
    </div>
</div>